import { Spin } from "antd";
import { useGetTenantQuery } from "api/Tenant/hooks";
import { TenantSettingsForm } from "components/Forms/TenantSettingsForm/TenantSettingsForm";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum } from "types/enums";
import { FormId } from "types/models";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getSettingHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/setting/_layout/general/")({
    component: GeneralSettingsPage,
    staticData: {
        permissions: [PermissionEnum.SettingGeneral],
        showInSideMenu: false,
        label: "pages.setting.general.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.setting.general.title"),
        };
    },
});

function GeneralSettingsPage() {
    const { t: tC } = usePaldockTranslation("common");
    const userUtils = useUser();
    const activeTenant = userUtils.getActiveTenant();

    const getTenantQuery = useGetTenantQuery(
        activeTenant?.id ?? "",
        { filter: { include: "catalogCategories" } },
        { enabled: !!activeTenant?.id }
    );

    if (!activeTenant) {
        return <>{tC("errors.no_tenant_id")}</>;
    }

    if (getTenantQuery.isLoading || !getTenantQuery.data) {
        return (
            <div className="flex justify-center items-center h-64">
                <Spin size="large" />
            </div>
        );
    }

    return (
        <TenantPage headerNavigationItems={getSettingHeaderItems} isEdit={true} saveFormId={FormId.TenantSettingsForm}>
            <TenantSettingsForm tenant={getTenantQuery.data.tenant} />
        </TenantPage>
    );
}
